/**
 * @generated SignedSource<<102b092291ea7336cb61b4ffc4fc5676>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesforceConfigurationConductor_viewer$data = {
  readonly company: {
    readonly newSalesforceEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "SalesforceConfigurationConductor_viewer";
};
export type SalesforceConfigurationConductor_viewer$key = {
  readonly " $data"?: SalesforceConfigurationConductor_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesforceConfigurationConductor_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesforceConfigurationConductor_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newSalesforceEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "34be013738256a443867af8e4d376ae1";

export default node;
